(function() {
  angular.module('benefits')
  .controller('selectMemberModelController', ['$uibModalInstance',  '$uibModal', 'Members', '$scope', '$state', '$filter',
     '$rootScope', 'uiGridConstants', 'gridServices', 'member', 'policy', 'benefitService',
    function($uibModalInstance, $uibModal, Members, $scope, $state, $filter,
      $rootScope, uiGridConstants, gridServices, member, policy, benefitService) {
      var vm = this;
      vm.member = member;
      vm.policy = policy;
      vm.minDate = '01/01/1900';
      vm.today   =  $filter('date')(new Date(),'MM/dd/yyyy');
      vm.isValid = true;
      vm.initMembers = initMembers;
      initMembers();
      
      function initMembers(){
        vm.memberNotFound = false;
        vm.isValid = true;
      }

      $scope.$watch('errorControl', function() {
          return $scope.errorControl && ($scope.errorControl.showErrors('dateRange') || $scope.errorControl.showErrors('validDate'));
      });

      function lookupParams(data) {
        let lookupParams = _.pick(vm.model,["subscriberId","dateOfBirth"]);
        lookupParams.subscriberId = $filter('subscriberId')(lookupParams.subscriberId);
        lookupParams.dateOfBirth = $filter('teledentDate')(lookupParams.dateOfBirth);
        return lookupParams;
      }
      
      vm.ok = function () {
    	$scope.errorControl.showErrors();
        if(!$scope.memberDobLookupForm.$valid){
    	  vm.isValid = false;
    	  $scope.errorControl.showErrors(); 
    	} else {
    	  vm.memberNotFound = false;
      	  vm.model.subscriberId = vm.member.subscriberId;
      	  vm.serviceUnavailable = false;
          Members.query(lookupParams(vm.model), (res) => {
            let data = res.data;
            vm.model.members = _.filter(data,(d) => {return d.subscriberId !== undefined;});
            if (vm.model.members.length > 0) {
              vm.refIdNotFound = true;
              _.each(vm.model.members,(member) => {
                if ((member.lastName === vm.member.lastName) && (member.firstName === vm.member.firstName)){
                  _.each(member.policies,(policy) => {  
                    if ((policy.groupNumber === vm.policy.groupNumber) && (policy.policyType === vm.policy.policyType )){
                      vm.model.referenceId = policy.referenceId;	
                	  vm.refIdNotFound = false;
                    }
                  });  
                }
              });
              if (!vm.refIdNotFound) {
                $state.go('benefits.dashboard', {'referenceId': vm.model.referenceId, 'subscriberId': vm.model.subscriberId, 'dateOfBirth': vm.model.dateOfBirth, 'expandAssociatedMembers': true});
        	    $uibModalInstance.close();	
              } else {
                vm.memberNotFound = true;	
              }
            } else if (res.serviceUnavailable) {
              vm.serviceUnavailable = true;
            } else {
              vm.memberNotFound = true;
            }
            vm.running = false;
          },(error) => {
            vm.running= false;
          });      	    
    	}
   	  };
      
   	  vm.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
 
  }]);
})();